import { render } from "./HcaptchaWidget.vue?vue&type=template&id=091ee5f4&scoped=true&ts=true"
import script from "./HcaptchaWidget.vue?vue&type=script&lang=ts"
export * from "./HcaptchaWidget.vue?vue&type=script&lang=ts"

import "./HcaptchaWidget.vue?vue&type=style&index=0&id=091ee5f4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091ee5f4"]])

export default __exports__